import React from 'react';
import PropTypes from 'prop-types';

const WidgetReloader = ({ onClick }) => {    
    return (
        <i className="fa fa-1 fa-refresh refresh-icon" onClick={onClick} />
    );
};

WidgetReloader.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default WidgetReloader;





// WEBPACK FOOTER //
// ./src/dashboard/widgets/WidgetReloader.js